import { render, staticRenderFns } from "./storeReturnRecord.vue?vue&type=template&id=2959751c"
import script from "./storeReturnRecord.vue?vue&type=script&lang=js"
export * from "./storeReturnRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports